moment = require('moment')

# Moment (and Angular's date filter) by default
# convert all times to the browser timezone, which
# can result in a change of date. All datetimes
# from django include the timezone and are UTC
# anyway, so we can show the original time from
# django by making sure we parse the date in UTC
# mode

angular.module('workflow.app')
  .filter 'arachnysDate', ( arachnysOutputDateFormat) ->
    return ( date ) ->
      moment.utc(date).format( arachnysOutputDateFormat )
  .filter 'arachnysDateTime', ( arachnysOutputDateTimeFormat ) ->
    return ( date ) ->
      moment.utc(date).format( arachnysOutputDateTimeFormat )
